<div>
  <div class="grid">
    <input
      class="form-control startField  square-input {{ startExtraClasses }}"
      #dpFromDate
      [value]="formatter.format(fromDate)"
      (input)="setStartInput(dpFromDate.value)"
      placeholder="MM/DD/YYYY"
      [disabled]="isDisabled" />
    <span
      class="input-group-text middleText form-control square-input"
      #p="ngbPopover"
      [ngbPopover]="popContent"
      [popoverTitle]="popTitle"
      [popoverClass]="showHelpers ? 'daterange-width' : ''"
      placement="bottom"
      [autoClose]="'outside'"
      container="body"
      >to</span
    >
    <div class="input-group">
      <input
        class="form-control endField datepicker  {{ endExtraClasses }} square-input"
        style="padding-right: 0.75px"
        #dpToDate
        [value]="formatter.format(toDate)"
        (input)="setEndInput(dpToDate.value)"
        placeholder="MM/DD/YYYY"
        [disabled]="isDisabled" />
      <button
        class="btn btn-tertiary buttons"
        type="button"
        [disabled]="isDisabled"
        (click)="openPopover(p)">
        <img src="assets/icons/calendar.svg" />
      </button>
      <button
        [disabled]="isDisabled"
        type="button"
        *ngIf="fromDate != null || toDate != null"
        (click)="clearDates()"
        class="text-danger btn btn-outline-danger buttons">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</div>
<ng-template #popTitle> Date Range </ng-template>
<ng-template #popContent>
  <div *ngIf="showHelperScreen(); else date">
    <div class="list-group-flush">
      <button
        *ngFor="let helper of helpers"
        class="list-group-item w-100 border-0 list-group-item-action"
        (click)="helperClicked(helper, p)">
        <div class="d-flex justify-content-between row">
          <span class="col-4 text-left">{{ helper.name }}</span
          ><span class="col-8 text-end"
            >{{ helper.start | date: 'dd MMM, yyyy' }} -
            {{ helper.end | date: 'dd MMM, yyyy' }}</span
          >
        </div>
      </button>
      <button
        (click)="customDateClicked()"
        class="list-group-item w-100 d-flex justify-content-between list-group-item-action">
        <span class="text-left">Custom Date Range</span
        ><span class="col-2 text-end"><i class="fas fa-caret-right"></i></span>
      </button>
    </div>
  </div>
  <ng-template #date>
    <ngb-datepicker
      #datepicker="ngbDatepicker"
      [firstDayOfWeek]="firstDayOfWeek"
      [minDate]="earliestDate"
      (dateSelect)="onDateSelection($event, p)"
      [displayMonths]="1"
      [dayTemplate]="t"
      outsideDays="hidden"
      [startDate]="fromDate! ?? toDate!"></ngb-datepicker>
    <ng-template #t let-date let-focused="focused" let-disabled="disabled">
      <span
        class="custom-day"
        [class.text-muted]="disabled"
        [class.focused]="focused"
        [class.range]="isRange(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        [class.start]="isStart(date)"
        [class.end]="isEnd(date)"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    </ng-template>
  </ng-template>
</ng-template>
